import i18next from 'i18next';

import { bulkItems } from 'common/api/systems';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import filterItems from './filterItems';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(actions[BULK_UPDATE_ITEMS]());

    const items = ids.map((id) => id);

    bulkItems({ items, status_flag: value })
        .then(() => {
            dispatch(actions[BULK_UPDATE_ITEMS_SUCCESS]());
            dispatch(filterItems(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            else showToast();
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                actions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
